module.exports = __webpack_public_path__ + "3c9ee6ce92ebb2344e8942c1905a33.png";